<span class="snackbar">
    {{data.message}}
  </span>
  